const KEY = (uid) => `np_applock_${uid}`;
export const LOCK_AFTER_MS = 2 * 60 * 1000;

const b64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
const unb64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
const rand = (n) => crypto.getRandomValues(new Uint8Array(n));

export const getLock = (uid) => { try { return JSON.parse(localStorage.getItem(KEY(uid))); } catch { return null; } };
export const saveLock = (uid, cfg) => localStorage.setItem(KEY(uid), JSON.stringify(cfg));
export const clearLock = (uid) => localStorage.removeItem(KEY(uid));

export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const nativeBio = () => window.Capacitor?.isNativePlatform?.() && window.Capacitor?.Plugins?.BiometricAuthNative;
const nativeAuth = (reason) => nativeBio().internalAuthenticate({ reason, cancelTitle: "Use PIN", androidTitle: "Unlock app", androidSubtitle: reason, allowDeviceCredential: false });

export async function bioAvailable() {
  if (nativeBio()) { try { return !!(await nativeBio().checkBiometry()).isAvailable; } catch { return false; } }
  try { return !!(window.PublicKeyCredential && await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()); } catch { return false; }
}

export async function hashPin(pin, salt) {
  const d = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(`${salt}:${pin}`));
  return b64(d);
}

export async function registerBio(user) {
  if (nativeBio()) { await nativeAuth("Enable fingerprint lock"); return "native"; }
  const cred = await navigator.credentials.create({ publicKey: {
    challenge: rand(32), rp: { name: "Retailer App", id: window.location.hostname },
    user: { id: rand(16), name: user.login_id, displayName: user.name },
    pubKeyCredParams: [{ type: "public-key", alg: -7 }, { type: "public-key", alg: -257 }],
    authenticatorSelection: { authenticatorAttachment: "platform", userVerification: "required", residentKey: "discouraged" }, timeout: 60000,
  } });
  return b64(cred.rawId);
}

export async function verifyBio(credId) {
  if (credId === "native") { await nativeAuth("Unlock app"); return true; }
  await navigator.credentials.get({ publicKey: { challenge: rand(32), allowCredentials: [{ type: "public-key", id: unb64(credId) }], userVerification: "required", timeout: 60000 } });
  return true;
}

export async function makePinLock(pin) {
  const salt = b64(rand(12));
  return { salt, pin: await hashPin(pin, salt) };
}

export async function checkPin(cfg, pin) {
  return (await hashPin(pin, cfg.salt)) === cfg.pin;
}
